module.exports = __webpack_public_path__ + "img/cash-assist.aa4ad05a.svg";